module.exports = __webpack_public_path__ + "static/img/安全教育网站.0d4f075.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/安全教育网站.png
// module id = cyCg
// module chunks = 13